import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import type { ChatFilters } from '@/types/chat';

interface ChatListFiltersProps {
  filters: ChatFilters;
  onChange: (filters: ChatFilters) => void;
}

export function ChatListFilters({ filters, onChange }: ChatListFiltersProps) {
  const [local, setLocal] = useState<ChatFilters>({
    phoneNumber: filters.phoneNumber ?? '',
    dateFrom: filters.dateFrom ?? '',
    dateTo: filters.dateTo ?? '',
  });

  function handleApply() {
    onChange({
      ...local,
      // Omit empty strings so they don't appear as query params
      phoneNumber: local.phoneNumber || undefined,
      dateFrom: local.dateFrom || undefined,
      dateTo: local.dateTo || undefined,
    });
  }

  function handleClear() {
    const cleared: ChatFilters = { phoneNumber: undefined, dateFrom: undefined, dateTo: undefined };
    setLocal({ phoneNumber: '', dateFrom: '', dateTo: '' });
    onChange(cleared);
  }

  return (
    <div className="flex flex-wrap items-end gap-3">
      <div className="flex flex-col gap-1">
        <Label htmlFor="filter-phone" className="text-xs text-muted-foreground">
          Número de telefone
        </Label>
        <Input
          id="filter-phone"
          placeholder="Filtrar por número"
          value={local.phoneNumber ?? ''}
          onChange={(e) => setLocal((prev) => ({ ...prev, phoneNumber: e.target.value }))}
          className="w-52"
        />
      </div>

      <div className="flex flex-col gap-1">
        <Label htmlFor="filter-date-from" className="text-xs text-muted-foreground">
          Data inicial
        </Label>
        <Input
          id="filter-date-from"
          type="date"
          value={local.dateFrom ?? ''}
          onChange={(e) => setLocal((prev) => ({ ...prev, dateFrom: e.target.value }))}
          className="w-40"
        />
      </div>

      <div className="flex flex-col gap-1">
        <Label htmlFor="filter-date-to" className="text-xs text-muted-foreground">
          Data final
        </Label>
        <Input
          id="filter-date-to"
          type="date"
          value={local.dateTo ?? ''}
          onChange={(e) => setLocal((prev) => ({ ...prev, dateTo: e.target.value }))}
          className="w-40"
        />
      </div>

      <div className="flex gap-2">
        <Button onClick={handleApply} size="sm">
          Aplicar
        </Button>
        <Button onClick={handleClear} variant="outline" size="sm">
          Limpar
        </Button>
      </div>
    </div>
  );
}
